// Anomali listesi
export const GET_ANOMALIES_SERVICE_REQUEST = "GET_ANOMALIES_SERVICE_REQUEST";
export const GET_ANOMALIES_SERVICE_SUCCESS = "GET_ANOMALIES_SERVICE_SUCCESS";
export const GET_ANOMALIES_SERVICE_FAILURE = "GET_ANOMALIES_SERVICE_FAILURE";

// Tek bir anomali getirme
export const GET_ANOMALY_BY_ID_SERVICE_REQUEST = "GET_ANOMALY_BY_ID_SERVICE_REQUEST";
export const GET_ANOMALY_BY_ID_SERVICE_SUCCESS = "GET_ANOMALY_BY_ID_SERVICE_SUCCESS";
export const GET_ANOMALY_BY_ID_SERVICE_FAILURE = "GET_ANOMALY_BY_ID_SERVICE_FAILURE";

// Anomali durumu güncelleme
export const UPDATE_ANOMALY_STATUS_SERVICE_REQUEST = "UPDATE_ANOMALY_STATUS_SERVICE_REQUEST";
export const UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS = "UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS";
export const UPDATE_ANOMALY_STATUS_SERVICE_FAILURE = "UPDATE_ANOMALY_STATUS_SERVICE_FAILURE";

// Anomali seviyesi güncelleme
export const UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST = "UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST";
export const UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS = "UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS";
export const UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE = "UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE";

// Anomali silme
export const DELETE_ANOMALY_SERVICE_REQUEST = "DELETE_ANOMALY_SERVICE_REQUEST";
export const DELETE_ANOMALY_SERVICE_SUCCESS = "DELETE_ANOMALY_SERVICE_SUCCESS";
export const DELETE_ANOMALY_SERVICE_FAILURE = "DELETE_ANOMALY_SERVICE_FAILURE";

// Action Creators
export const getAnomaliesServiceRequest = (params) => ({
  type: GET_ANOMALIES_SERVICE_REQUEST,
  payload: params,
});

export const getAnomalyByIdServiceRequest = (id) => ({
  type: GET_ANOMALY_BY_ID_SERVICE_REQUEST,
  payload: id,
});

export const updateAnomalyStatusServiceRequest = (id, status) => ({
  type: UPDATE_ANOMALY_STATUS_SERVICE_REQUEST,
  payload: { id, status },
});

export const updateAnomalyLevelServiceRequest = (id, level) => ({
  type: UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST,
  payload: { id, level },
});

export const deleteAnomalyServiceRequest = (id) => ({
  type: DELETE_ANOMALY_SERVICE_REQUEST,
  payload: id,
});